module.exports = __webpack_public_path__ + "img/ig.d6bc89eb.svg";